import config from '@config/build'
import _, { isNil, isNumber, isString } from 'lodash'
import { transferConfig, getCommonParams } from '@extension/utils'
import qs from 'qs'
import { Message } from 'element-ui'

export function obj2Params(obj, isQueryString) {
  if (typeof obj !== 'object') {
    return null
  }
  Object.keys(obj).forEach((key) => {
    if (
      (typeof obj[key] === 'string' && !obj[key]) ||
      typeof obj[key] === 'undefined' ||
      obj[key] === null
    ) {
      delete obj[key]
    }
  })
  const searchParams = new URLSearchParams()
  Object.keys(obj).forEach((key) => {
    if (obj[key] instanceof Array) {
      searchParams.append(key, JSON.stringify(obj[key]))
      return
    }
    if (obj[key] instanceof Object) {
      searchParams.append(key, JSON.stringify(obj[key]))
    } else {
      searchParams.append(key, obj[key])
    }
  })
  return searchParams
}

export function getType(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1)
}

export function cloneDeep(obj) {
  if (obj) {
    return JSON.parse(JSON.stringify(obj))
  }
}
// elvish改造，formatQuery和getTimesTampByDate方法没有实际使用，删除

export function isNull(data) {
  if (data === 0) return false
  if (!data) return true
  if (Array.isArray(data) && !data.length) return true
  if (typeof data === 'object' && !Object.keys(data).length) return true

  return false
}

export function isEmpty(value) {
  const hasOwnProperty = Object.prototype.hasOwnProperty
  if (value == null) {
    return true
  }
  for (const key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false
    }
  }
  return true
}
/**
 * 根据配置筛选结构化数据
 * @param  {[type]} paramsKeys 参数配置
 * @param  {[type]} data       数据源
 * @return {[type]}            结构化后数据
 */
export function filterParams(paramsKeys, data) {
  if (!data) {
    return {}
  }
  const copyParamsKeys = _.cloneDeep(paramsKeys)
  return copyParamsKeys.reduce((params, item) => {
    // 单纯的字段摘取
    if (typeof item === 'string') {
      params[item] = data[item]
      return params
    }
    // 参数结构化函数
    if (item.format) {
      params[item.newKey || item.key] = item.format(data[item.key], data)
      return params
    }
    // 参数默认值
    if (item.default) {
      params[item.newKey || item.key] = item.default
      return params
    }
    return params
  }, {})
}

/**
 * key=value& 字符串转化成 Object
 * @param {[type]} search key=value&字符串
 */
export function URLSearch2Params(search = window.location.search) {
  const values = search.split('?')
  if (values && values.length && values[1]) {
    return values[1].split('&').reduce((params, keyValue) => {
      return Object.assign(params, {
        [keyValue.split('=')[0]]: keyValue.split('=')[1] || '',
      })
    }, {})
  }
  return {}
}

/**
 * 关于接口图片字段的结构化
 * @param  {Array}  urls 图片url
 * @param  {Object} keys 上传图片时返回的key
 * @return {[type]}      结构化后数据，便于组件使用
 */
export function picDataFormat(urls, keys) {
  if (!urls) {
    urls = []
  }
  if (!keys) {
    keys = []
  }
  urls = urls.filter((item) => item)
  return urls.map((item, index) => {
    return {
      url: item,
      key: keys[index] || '',
      name: keys[index] || '',
    }
  })
}

/**
 * 获取字符长度 一个中文字符等于2长度
 * @param  {String} str 字符串
 * @return {[type]}     字符串长度
 */
export function getStringLength(str = '') {
  if (!str) {
    return 0
  }
  if (typeof str !== 'string') {
    str += ''
  }
  return str.replace(/[^x00-xff]/g, '01').length
}

/**
 * 1. 输入url，params，自动拼接url和查询参数
 * 2. 输入xxx.xxx.xxx自动转换url + 参数
 * @param url：下载链接 || xxx.xxx.xxx
 * @param params: 查询拼接参数
 * @param options.isFilterEmptyParams: 是否过滤空参数
 * @param options.isAddCommonParams: 是否添加公共参数(timezone,ticket,country)
 * @returns {string|*}
 */
export function prefixUrl(
  url,
  params,
  options = {
    isFilterEmptyParams: false,
    isAddCommonParams: false,
    isArrayParams: false,
  }
) {
  let tmpParams = { ...params }
  if (options.isFilterEmptyParams) {
    // 过滤错误函数
    tmpParams = _.omitBy(
      tmpParams,
      (v) => _.isNaN(v) || _.isUndefined(v) || _.isNull(v) || v === ''
    )
  }
  if (options.isAddCommonParams) {
    const commonParams = getCommonParams()
    tmpParams = {
      ...commonParams,
      ...tmpParams,
    }
  }
  // url处理逻辑
  if (url && url.indexOf('http') < 0) {
    if (url.indexOf('/') === 0) {
      if (/^\/?depot/g.test(url)) {
        url = config.depot + url
      } else if (/^\/?pms/g.test(url)) {
        url = config.pms + url
      } else if (/^\/?authmanage/g.test(url)) {
        url = config.dilu_api + url
      } else if (/^\/?banner-mis/g.test(url)) {
        url = config['banner-mis'] + url
      } else if (/^\/?act-mis/g.test(url)) {
        url = config['act-mis'] + url
      } else if (/^\/?activation/g.test(url)) {
        url = config.activation + url
      } else if (/^\/?msgcenter-api/g.test(url)) {
        url = config['msgcenter-api'] + url
      } else if (/^\/?m-transaction\/invoice/g.test(url)) {
        url =
          config['m-transaction-invoice'] +
          url.replace(/^\/?m-transaction/g, '')
      } else if (/^\/?m-transaction\/rfc/g.test(url)) {
        url =
          config['m-transaction-rfc'] + url.replace(/^\/?m-transaction/g, '')
      } else if (/^\/?deal/g.test(url)) {
        url = config.deal + url.replace(/^\/?deal/g, '')
      } else if (/^\/?home-conf/g.test(url)) {
        url = config['home-conf'] + url
      } else if (/^\/?m-transaction\/supply/g.test(url)) {
        url =
          config['m-transaction-supply'] + url.replace(/^\/?m-transaction/g, '')
      } else if (/^\/?workshop/g.test(url)) {
        url = config.workshop + url
      } else if (/^\/?gateway/g.test(url) || /^\/?common/g.test(url)) {
        url = config.gateway + url
      } else {
        url = config.api + url
      }
    } else {
      // 如果是xxx.xxx.xxx兼容
      const { transUrl, transParams } = transferConfig(url)
      tmpParams = { ...transParams, ...tmpParams }
      if (options.isArrayParams) {
        url =
          config.gateway +
          transUrl +
          '?' +
          qs.stringify(tmpParams, { arrayFormat: 'brackets', allowDots: true })
      } else {
        url = config.gateway + transUrl + '?' + qs.stringify(tmpParams)
      }
      return url
    }
  }
  // 参数处理逻辑
  if (url.indexOf('?') !== -1) {
    return url
  } else if (!_.isEmpty(tmpParams)) {
    return url + '?' + qs.stringify(tmpParams)
  }
  return url
}

export function decimalAdjust(value, exp) {
  if (+exp === 0) {
    return value
  }
  value = +value
  exp = +exp
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN
  }
  // Shift
  value = value.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp))
}

/**
  精确四舍五入
  @param {Number} value 待处理数
  @param {Number} exp 要舍的位数，负数为小数点后的位数，如-2为四舍五入小数点后两位
 */
export function round(value, exp) {
  value = +value
  exp = +exp
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN
  }
  // Shift
  value = value.toString().split('e')
  value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)))
  // Shift back
  value = value.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp))
}

/**
 * 表单、info 布局结构
 * @param  {[type]} list 配置列表
 * @return {[type]}      结构化后数据
 */
export function gridFormat(list) {
  const gridFormat = []
  let linePointer = 0
  let tempGrid = []
  list.forEach((config) => {
    if (_.get(config, 'grid') !== linePointer) {
      linePointer = config.grid
      if (tempGrid.length) {
        gridFormat.push(tempGrid)
        tempGrid = []
      }
    }
    tempGrid.push(config)
  })
  gridFormat.push(tempGrid)
  return gridFormat
}
/**
  批量转换state为同名mutations方法
*/
export function stateToMutations(attrs) {
  const res = {}
  attrs.forEach((item) => {
    res[item] = function (state, data) {
      state[item] = data
    }
  })
  return res
}
/**
 * 服务端下放配置和本地配置merge
 * @param {Array} base 服务端下放的format配置
 * @param {Object} extend 本地需要继承的对应配置，key为format.prop
 */
export function sodaMerge(base, extend) {
  if (extend == null) return base

  if (base == null) return []

  if (!_.isArray(base))
    throw new Error('[Error] base only support Array object.')

  return base.map((format) => {
    if (format.prop in extend) {
      return {
        ...extend[format.prop],
        ...format,
      }
    } else {
      return format
    }
  })
}

export function filterConfByKeys(configs, keys) {
  return configs.map((conf) => {
    return {
      ...conf,
      disabled: !keys.some((item) => item === conf.prop),
    }
  })
}

/**
 * 禁止configs by keys
 * @param configs
 * @param disabled
 * @returns {*}
 */
export function disabledConf(configs, disabled = true) {
  return configs.map((conf) => {
    return {
      ...conf,
      disabled,
    }
  })
}

export function fillValueByConf(configs, data) {
  return (
    configs

      // eslint-disable-next-line array-callback-return
      .map((conf) => {
        let value
        if (conf.viewType === 'map') {
          value = _.get(conf, 'mapConfig', []).reduce((map, item) => {
            map[item.value] = item.label
            return map
          }, {})[_.get(data, conf.prop)]
        } else if (conf.viewType === 'file') {
          value = (_.get(data, conf.prop, []) || []).map((item) => {
            return item && item.url ? item.url : item
          })
        } else {
          value = _.get(data, conf.prop)
        }
        if (conf.label && !conf.viewDisabled) {
          if (
            Object.prototype.toString.call(_.get(data, conf.prop)) ===
            '[object Object]'
          ) {
            const d = {
              ...conf,
              hide: conf.checkVisible ? !conf.checkVisible(data) : false,
              value,
              type: conf.viewType ? conf.viewType : conf.type,
              images:
                conf.viewType === 'image'
                  ? (_.get(data, conf.prop, {}) || {}).urls.map((item) => {
                      return item.url || item
                    })
                  : '',
            }
            return d
          } else {
            try {
              let arr = _.get(data, conf.prop, [])
              arr = Array.isArray(arr) ? arr : []
              return {
                ...conf,
                hide: conf.checkVisible ? !conf.checkVisible(data) : false,
                value,
                type: conf.viewType ? conf.viewType : conf.type,
                images:
                  conf.viewType === 'image'
                    ? arr.map((item) => {
                        return item.url || item
                      })
                    : '',
              }
            } catch (e) {
              console.warn(e)
            }
          }
        } else {
          return ''
        }
      })
      .filter((item) => item)
  )
}

export function getRandomColor() {
  return '#' + Math.floor(Math.random() * 16777215).toString(16)
}

export function generateNum(startNum, endNum, range, includeLeft, includeEnd) {
  const result = []
  for (let i = startNum; i <= endNum; i = i + range) {
    result.push(i)
  }
  if (!includeLeft) {
    result.splice(0, 1)
  }
  if (!includeEnd) {
    result.splice(-1, 1)
  }
  return result
}

/**
 * 小数转化成百分比
 * 1.先转化为number类型
 * 2.再乘以100
 * 3.保留小数位
 * @param figure 转成百分比以后要保留的位数
 * @returns {string}
 */
export function toPercent(point, figure = 2) {
  let percent = Number(point * 100).toFixed(figure)
  percent += '%'
  return percent
}

export function formatCPF(str) {
  return str.replace(
    /^(\d{3})(\d{0,3})(\d{0,3})(\d{0,2})/,
    (matchStr, first, second, thrid, four, five) => {
      let newStr = ''
      newStr = first
      if (second) {
        newStr = newStr + '.' + second
      }
      if (thrid) {
        newStr = newStr + '.' + thrid
      }
      if (four) {
        newStr = newStr + '-' + four
      }
      return newStr
    }
  )
}

export function formatCNPJ(str) {
  return str.replace(
    /^(\d{2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/,
    (matchStr, first, second, thrid, four, five) => {
      let newStr = ''
      newStr = first
      if (second) {
        newStr = newStr + '.' + second
      }
      if (thrid) {
        newStr = newStr + '.' + thrid
      }
      if (four) {
        newStr = newStr + '/' + four
      }
      if (five) {
        newStr = newStr + '-' + five
      }
      return newStr
    }
  )
}

export function str2path(path) {
  const ret = []
  if (!_.isString(path)) {
    return []
  }
  const keys = path.split('.')
  keys.forEach(function transKey(key) {
    const start = key.indexOf('[')
    const end = key.indexOf(']')
    if (start > -1 && end > -1) {
      const str = key.substring(0, start)
      if (str !== '') {
        ret.push(str)
      }
      ret.push(parseInt(key.substring(start + 1, end), 10))
    } else {
      ret.push(key)
    }
  })
  return ret
}
// 获取电话号码 国际电话区号 前缀
export function getPhonePreText(country) {
  const preText = {
    BR: '+55',
    JP: '+81',
    MX: '+52',
  }
  return _.get(preText, country, '')
}

// @method 自适应获取宽高度值
// @params: cont: 被减数number，othersArr：其他减数 Array<number>，
// padding：要留取的边界number,type：设定最大值或最小值string: {max, min}，threshold：阀值number
export function getPxNumner(configs) {
  const { cont, othersArr, padding, type, threshold } = configs
  const others =
    (othersArr &&
      othersArr.length &&
      othersArr.reduce((pre, index) => {
        return pre + index
      })) ||
    0
  const result = cont - others - padding
  return type === 'max'
    ? result > threshold
      ? threshold
      : result
    : result < threshold
    ? threshold
    : result
}
// 节流函数
export function throttle(fn, delay) {
  let timer = null
  let remaining = 0
  let previous = new Date()
  return function () {
    const now = new Date()
    remaining = now - previous
    const args = arguments
    const context = this
    if (remaining >= delay) {
      if (timer) {
        clearTimeout(timer)
      }
      fn.apply(context, args)
      previous = now
    } else {
      if (!timer) {
        timer = setTimeout(function () {
          fn.apply(context, args)
          previous = new Date()
        }, delay - remaining)
      }
    }
  }
}

// 随机颜色生成
export function randomColorRGB() {
  let rgb = ''
  for (let i = 0; i < 3; i++) {
    rgb = rgb + Math.floor(Math.random() * 255) + (i === 2 ? '' : ',')
  }
  return 'rgb(' + rgb + ')'
}

/**
 * @descripttion: 处理js浮点数
 * @param: num要处理的数
 * @param: fixed要保留几位小数
 */
export function formatFloat(num, fixed) {
  // Math.pow(指数，幂指数)
  const m = Math.pow(10, fixed)
  // Math.round（） 四舍五入
  return Math.round(num * m, 10) / m
}

/**
 * @descripttion: 解决Message多次弹窗问题
 * @param: { message, time = 3000, type = 'error', showClose = false }
 * @return: null
 */
const messageList = []
export const messageTips = ({
  message,
  duration = 3000,
  type = 'error',
  showClose = false,
}) => {
  if (messageList.length === 0) {
    messageList.push('messageBox')
    Message({
      showClose,
      message,
      type,
      duration,
      onClose: () => {
        messageList.pop()
      },
    })
  }
}
/**
 * 获取系统信息
 * @returns {string}
 */
export function getOSInfo() {
  const userAgent = navigator.userAgent
  if (/win/i.test(userAgent)) return 'window'
  if (/mac/i.test(userAgent)) return 'mac'
  if (/Android/i.test(userAgent)) return 'android'
  if (/iphone|ipad|ipod|ios/i.test(userAgent)) return 'ios'
}

/**
 * @descripttion: url cityIds 转换nubmer
 * @param:
 * @return: cityIds
 */
export function fixCityIds(cityIds) {
  try {
    if (getType(cityIds) === 'Array') {
      return cityIds.map((_) => Number(_))
    }
    return Array.from({ ...cityIds, length: Object.keys(cityIds).length }).map(
      (_) => Number(_)
    )
  } catch (e) {
    console.log(e)
    return []
  }
}

/**
 * @descripttion: 城市多选tag组件数据源，去掉大区id生成
 * @param: nameList
 * @return: { shopIds: [shopId], cityIds: [cityId]... }
 */
export function fillterCityNameList(nameList = {}) {
  const list = []
  for (const item of Reflect.ownKeys(nameList)) {
    const obj = nameList[item]
    list.push(obj)
  }
  return list
}

/**
 * @descripttion: 城市多选tag组件数据源，根据cityIds 查找对应的 大区id和 大区name以及自身的 cityname根据 大区id聚合大区namecityname和cityid
 * @param: cityList 多城组件ready的list数据, cityIds = []
 * @return: fillterCityNameList
 */
export function fillterCityList(cityList = [], cityIds = []) {
  const obj = {}
  try {
    if (cityIds.length !== 0 && cityList.length !== 0) {
      cityIds.forEach((cityId) => {
        cityList.forEach((cityListItem) => {
          cityListItem.children.forEach((cityListChildren) => {
            if (cityListChildren.value === Number(cityId)) {
              if (obj[cityListItem.value]) {
                obj[cityListItem.value].children.push(cityListChildren)
              } else {
                obj[cityListItem.value] = {
                  label: cityListItem.label,
                  children: [cityListChildren],
                }
              }
            }
          })
        })
      })
    }
    return fillterCityNameList(obj)
  } catch (e) {
    console.log(e)
  }
}

/**
 * @descripttion: 城市多选tag组件删除逻辑
 * @param: cityIds cityId
 * @return: 过滤后的cityIds
 */
export function fillterCityClose(cityIds, cityId) {
  // eslint-disable-next-line array-callback-return
  const filterCityIds = cityIds.filter((_) => {
    if (Number(_) !== cityId) {
      return _
    }
  })
  return filterCityIds
}

/**
 * 校验是否为允许的非负最多两位小数的数字
 * 通过返回true，不通过返回false
 * @param {string|number} value
 * @returns {boolean}
 */
export function isValidTwoDecimal(value) {
  if (value === undefined || value === null || value === '') {
    return true
  }
  value = value + ''
  // 不允许负数，允许整数和一或两位小数，不允许结尾带小数点
  const reg = /^(0|[1-9]\d*)(\.\d{1,2})?$/

  // 不通过的情况：1. 不符合正则 2. 结尾带小数点
  if (!reg.test(value)) {
    return false
  }
  // 明确排除结尾为点的情况
  if (value.endsWith('.')) {
    return false
  }
  return true
}

/**
 * 校验是否为数字
 * 通过返回true，不通过返回false
 * @param {string|number} value
 * @returns {boolean}
 */
export function isDecimalNumber(value) {
  if (value === undefined || value === null || value === '') {
    return true
  }

  return /^[\d.]+$/.test(value)
}

/**
 * 处理额外佣金比例的格式问题
 * @param {*} value sample as `15%`
 * @returns pure number string as `15`
 */
export function extraPercentTypo(value) {
  if (value === '' || isNil(value)) return ''
  if (isNumber(value)) return `${value}`
  if (isString(value) && value.length > 0) return value.split('%')[0]
}
